export default "__VITE_ASSET__D4iSaWd9__"